import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@services/auth/token.service';
import { SharedService } from '@services/shared/shared.service';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { commonDtOptions, theads } from './table.definition';
@Component({
  selector: 'app-batch-details',
  templateUrl: './batch-details.component.html',
  styleUrls: ['./batch-details.component.scss'],
})
export class BatchDetailsComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  public datatableElement: DataTableDirective;
  public dtOptions: any = {};
  public batchId: string;
  public theads = theads;
  public tableData: object[] = [];
  public eventListener: () => void;
  public searchKey: string = '';
  public searchableColumnIndex: number;
  public batchInfo: object;

  constructor(
    public sharedService: SharedService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private tokenService: TokenService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.batchId = this.activatedRoute.snapshot.paramMap.get('batchId');

    if (this.batchId) {
      this.dtOptions = this.getDtOptions();
    }
  }

  ngAfterViewInit(): void {
    this.eventListener = this.renderer.listen('document', 'click', (event) => {
      if (event.target && event.target.closest('.view-btn')) {
        const productId = event.target
          .closest('.view-btn')
          .getAttribute('data-product-id');

        if (productId) {
          this.router.navigate([
            `/dashboard/inventory/vehicle-details/${productId}`,
          ]);
        }
      }
    });

    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      const searchableColumns = document.querySelectorAll('.searchable-column');

      if (!searchableColumns.length) {
        return;
      }

      searchableColumns.forEach((searchableColumn) => {
        searchableColumn.addEventListener('keyup', () => {
          const column = dtInstance.column(this.searchableColumnIndex);

          if (column.search() !== this.searchKey) {
            column.search(this.searchKey).draw();
          }
        });
      });
    });
  }

  ngAfterViewChecked(): void {
    // This is for to fix the style for show entries
    const parentElement = document.getElementById('batch-vehicles_length');

    if (parentElement) {
      const labelElement = parentElement.querySelector('label');

      if (labelElement) {
        Object.assign(labelElement.style, {
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
        });

        const selectElement = labelElement.querySelector('select');

        if (selectElement) {
          selectElement.style.width = '5rem';
        }
      }
    }
  }

  ngOnDestroy(): void {
    this.eventListener();
  }

  getDtOptions() {
    return {
      ...commonDtOptions,
      ajax: (dataTablesParameters: any, callback) => {
        this.http
          .get(`${environment.api}inventory/batch/view/${this.batchId}`, {
            headers: this.tokenService.getTokenHeader(),
          })
          .subscribe((resp) => {
            this.batchInfo = resp?.['data']?.[0];
            this.tableData = this.sharedService.prepareBulkVehicles(
              resp['data']?.slice(1)
            );

            callback({
              recordsTotal: resp?.['data']?.[0]?.['total_rows'] || 0,
              recordsFiltered: resp?.['data']?.[0]?.['total_rows'] || 0,
              data: this.tableData,
            });
          });
      },
    };
  }

  searchVehicle(event: Event, columnIndex: number) {
    this.searchKey = (event.target as HTMLInputElement).value;
    this.searchableColumnIndex = columnIndex;
  }
}
